module.exports = __webpack_public_path__ + "13697c98b68e73b5c612556ab347dd2a.png";